import React from 'react';
import { Route, Routes } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import {
	Container, DataService, XpSourceType,
} from '../../../../../symphony';
import { LessonWidget } from './LessonWidget/LessonWidget';
import { LessonPagesContainer } from '../../LessonPagesContainer/LessonPagesContainer';
import { LessonCompleteContainer } from '../../LessonCompleteContainer/LessonCompleteContainer';
import { IMaterialProps } from '../../../global-interface';
import { MaterialType } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

import s from './Lesson.scss';
import { SkipAheadWidget } from './SkipAheadWidget/SkipAheadWidget';
import { SlLEContext } from '../../../global-constants';
import { SlDataService } from '../../../services/sl-data.service';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';

export function Lesson({
	materialInfo,
	children,
}: IMaterialProps): JSX.Element {
	useStyles(s);
	if (materialInfo?.options?.parentType) {
		const { xpSourcesList$ } = Container.take('global', DataService);
		const { currentItems$: currentItems } = useContainerData(SlLEContext, SlDataService, ['currentItems$']);

		const xpSourceType = materialInfo.header.typeId === MaterialType.Booster
			? XpSourceType.BoosterComplete
			: XpSourceType.LessonComplete;

		const xp = xpSourcesList$.value?.xpSources.find(
			({ xpSource }) => xpSource === xpSourceType,
		)?.xp;

		if (materialInfo.header.typeId === MaterialType.SkipAhead && materialInfo.header.parentRelationId === currentItems[0]?.moduleId) {
			return (
				<SkipAheadWidget
					materialInfo={materialInfo}
				/>
			);
		}

		if (
			materialInfo.header.typeId === MaterialType.Lesson ||
			materialInfo.header.typeId === MaterialType.ModuleQuiz ||
			materialInfo.header.typeId === MaterialType.Booster
		) {
			return (
				<LessonWidget
					materialInfo={{
						...materialInfo,
						options: {
							...materialInfo.options,
							xp,
						},
					}}
				/>
			);
		}

		return null;
	}

	return (
		<Routes>
			<Route
				path="/complete"
				element={(<LessonCompleteContainer />)}
			/>
			<Route
				path="*"
				element={(
					<LessonPagesContainer materialInfo={materialInfo}>
						{children}
					</LessonPagesContainer>
				)}
			/>
		</Routes>
	);
}
